var map = {
	"./AUD.png": "a882",
	"./BTC.png": "25d2",
	"./CAD.png": "67f5",
	"./ETH.png": "ad93",
	"./EUR.png": "233e",
	"./GBP.png": "0c23",
	"./HKD.png": "6da7",
	"./INR.png": "c37f",
	"./JPY.png": "c40a",
	"./NZD.png": "25a0",
	"./PLN.png": "ea56",
	"./SGD.png": "b8ce",
	"./USC.png": "c1e6",
	"./USD.png": "320a",
	"./UST.png": "8697"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5acd";